import {selectSessionUser} from "../../../../../store/authentication/selectors";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation} from "react-router";
import {useSelector} from "react-redux";
import constants from "../../../../../config/constants";
import * as io from "socket.io-client";
import "../BoardGame.css";
import Box from "@mui/material/Box";
import ConsultScreen from "./consultScreens/ConsultScreen";
import MainTurnState from "./mainScreens/MainTurnState";
import StateIntro from "./mainScreens/StateIntro";
import ConfirmModal from "../terraforming/utils/Modal";
import DiscardCardsState from "./mainScreens/DiscardCardsState";
import BuildingState from "./mainScreens/BuildingState";
import DefaultChoiceState from "./mainScreens/DefaultChoiceState";
import AssociationChoiceState from "./mainScreens/AssociationChoiceState";
import SelectCards from "./mainScreens/SelectCards";
import DrawCardPopup from "./components/DrawCardPopup";


export const ArkNovaHome = () => {

    const history = useHistory();
    const location = useLocation();

    const [state, setState] = useState({
        state: undefined,
        play: true,
        consult: "hands",
        checkNewState: false
    });

    const [confirmAction, setConfirmAction] = useState(undefined);

    const [drawCardQueue, setDrawCardQueue] = useState([]);

    const user = useSelector(selectSessionUser);

    let [socket, setSocket] = useState(undefined);

    const gameId = location.pathname.split("/")[2];

    useEffect(() => {
        const tempSocket = io.connect(constants.api.socketPath);
        setTimeout(() => {
            tempSocket.emit("id", {
                type: "PLAYER",
                gameId,
                userId: "" + user._id,
                username: user.username,
                color: {r: 1, g: 1, b: 1, a: 1}
            })
        }, 1000);
        tempSocket.on('disconnect', function () {
            history.push("/board-games");
        });
        tempSocket.on('state', function (data) {
            console.log('new state');
            console.log(data);
            if (data && (data.state !== "INTRO" || !state.state)) {
                setState(state => {
                    const newState = {state: data};
                    if (state.play && (!data.actions || !data.actions[user._id] || !data.actions[user._id].length)) {
                        newState.play = false;
                        newState.checkNewState = false;
                    } else if (!state.play && data.actions && data.actions[user._id] && data.actions[user._id].length && !state.checkNewState) {
                        newState.play = true;
                        newState.checkNewState = true;
                    }
                    return {...state, ...newState};
                });
            }
        });
        tempSocket.on('state_intro', function (data) {
            console.log('new state intro');
            console.log(data);
            setState(state => {
                if (!state.state || state.state.state === "INTRO") {
                    return {...state, state: data};
                }
                return state;
            });
        });
        tempSocket.on('special', function (data) {
            console.log('new special');
            console.log(data);
            if (data && data.type === "DRAW_CARD" && data.card && "" + data.playerId === "" + user._id) {
                setDrawCardQueue(queue => [...queue, data.card]);
            }
        })
        setSocket(tempSocket);
        return () => {
            tempSocket.close();
        };
    }, []);

    let modal = confirmAction ? <ConfirmModal
        action={confirmAction.action}
        text={confirmAction.message}
        socket={socket}
        onDismiss={() => setConfirmAction(undefined)}
        open={!!confirmAction}
    /> : undefined;

    const drawCardPopup = <DrawCardPopup
        queue={drawCardQueue}
        onDismissTop={() => setDrawCardQueue(queue => queue.slice(1))}
    />;

    let comp = undefined;
    if (!state.state) {
        return <React.Fragment>
            {drawCardPopup}
            <div style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                paddingTop: "15vh",
                marginBottom: "90vh"
            }}>
                Veuillez patienter
            </div>
        </React.Fragment>
    }
    if (state.state) {
        switch (state.state.state) {
            case "MAIN_TURN":
                comp = <MainTurnState
                    state={state.state}
                    userId={user._id}
                    setConfirmAction={setConfirmAction}
                    socket={socket}/>
                break;
            case "DISCARD_CARDS":
            case "PERCEPTION":
            case "HUNTER":
            case "SUNBATHING":
            case "RELEASE":
            case "SCAVENGER":
            case "POUCH":
            case "MARK_ANIMAL":
            case "SHARK_ATTACK":
            case "SCUBA_DIVE":
            case "GLIDE":
            case "DISCARD_ENDGAME":
            case "HORSE_WHISPERER":
            case "DRAFT":
            case "ANIMAL":
            case "SPONSOR":
            case "PLAY_SPONSOR_WITH_MONEY":
            case "DRAW_CARDS":
                comp = <SelectCards
                    state={state.state}
                    userId={user._id}
                    setConfirmAction={setConfirmAction}
                    socket={socket}/>
                break;
            case "TRANSFERT":
            case "UNIVERSITY":
            case "ZOO_PARTNER":
            case "IMPROVE_ACTION_CARD":
            case "CHOOSE_EFFECTS":
            case "CHOOSE_ENCLOSURE_FOR_ANIMAL":
            case "CONSERVATION":
            case "CHOOSE_CONSERVATION_BONUS":
            case "X_TOKEN_MULTIPLIER":
            default:
                comp = <DefaultChoiceState
                    state={state.state}
                    userId={user._id}
                    setConfirmAction={setConfirmAction}
                    socket={socket}/>
                break;
            case "ASSOCIATION":
                comp = <AssociationChoiceState
                    state={state.state}
                    userId={user._id}
                    setConfirmAction={setConfirmAction}
                    socket={socket}/>
                break;
            case "BUILDING":
            case "PLACE_BUILDING_FOR_FREE":
                comp = <BuildingState
                    state={state.state}
                    userId={user._id}
                    setConfirmAction={setConfirmAction}
                    socket={socket}/>
                break;
            case "INTRO":
                return <React.Fragment>
                    {drawCardPopup}
                    <div style={{
                        width: "100%",
                        height: "100%",
                        minHeight: '100vh',
                        display: "flex",
                        flexDirection: 'column',
                        justifyContent: "flex-start",
                        alignItems: "center",
                        fontSize: "20px"
                    }}>
                        <StateIntro
                            state={state.state}
                            userId={user._id}
                            gameId={gameId}
                            username={user.username}
                            socket={socket}
                        />
                    </div>
                </React.Fragment>;
                break;
        }
    }
    return <div style={{width: "100%", height: "100%", marginTop: "-1px", minHeight: "100vh"}}>
        {drawCardPopup}
        {modal}
        <div className="board-game-home-top-bar" style={{zIndex: 99}}>
            <div
                className={"board-game-home-top-button board-game-home-top-button-" + (state.play ? "active" : "inactive")}
                onClick={() => setState(state => {
                    if (state.state.actions[user._id] && state.state.actions[user._id].length) {
                        return {...state, play: true};
                    }
                    return state;
                })}>
                {state.state.actions[user._id] && state.state.actions[user._id].length ?
                    "JOUER" :
                    "EN ATTENTE"
                }
            </div>
            <div
                className={"board-game-home-top-button board-game-home-top-button-" + (!state.play ? "active" : "inactive")}
                onClick={() => setState(state => ({...state, play: false}))}>
                CONSULTER
            </div>
        </div>
        {
            state.play ?
                <Box className="board-game" sx={{width: {xs: "80%", md: "50%"}}}>
                    {
                        comp || JSON.stringify(state.state)
                    }
                </Box>
                : <ConsultScreen
                    state={state.state}
                    userId={user._id}
                />
        }
    </div>

}

export default ArkNovaHome;
